/* ═══════════════════════════════════════════════════════════════════════════
   FILE: isodash-standalone.js · v299
   Standalone-Bootstrap: mountet EIN IsoDash-Modul auf einer normalen Theme-Seite
   (z.B. /pages/trocknungs-guide, /pages/wirkung, /pages/feuchtigkeitsanalyse) —
   OHNE Shell/Loader. Optionaler data-iso-nav am #mod biegt Modul-Routen auf eigene
   URLs um (z.B. analyse-Abschluss -> /pages/kalkulator).

   Vertrag (identisch zur Shell, isodash-shell.js ~Z.2291):
     IsoDashModules[name].mount({ root, store, navigate, isMobile })

   Erwartetes Markup im Liquid-Template:
     <div id="isodash" data-theme="light">
       <div id="mod" data-iso-module="zeit" data-iso-prefix="trocknung"></div>
     </div>
   - id="isodash" + inneres id="mod" sind PFLICHT (CSS-Scoping der ds-Dateien).
   - data-theme="light" ist hart gesetzt: verhindert Dark-Mode-Leak aus
     localStorage 'ih_theme' von Dashboard-Besuchern.
   - Skript-Reihenfolge im Template (alle defer): dashboard-mod-utils.js →
     dashboard-calculations.js → dashboard-mod-<modul>.js → DIESES Skript.
═══════════════════════════════════════════════════════════════════════════ */
(function (w, d) {
  'use strict';

  if (w.__ISODASH_STANDALONE__) return;
  w.__ISODASH_STANDALONE__ = true;

  /* Routen, die als eigene Seite existieren; alles andere → Dashboard */
  var NAV_URLS = {
    zeit: '/pages/trocknungs-guide',
    wirkung: '/pages/wirkung'
  };
  var DASHBOARD_URL = '/pages/kalkulator'; /* v312.6: Ergebnis/Berechnung lebt auf /pages/kalkulator — NIE /pages/sanierungsplan */
  var WHATSAPP_URL = 'https://wa.me/491708449472';

  function track(event, data) {
    try {
      /* A6 (Auftrag 2026-09): ohne step routet theme.liquid auf /goal — jedes Ereignis
         wuerde als Conversion zaehlen und den Kauf-Zaehler "converted" faelschen. */
      if (typeof w.logr3Track === 'function') { w.logr3Track(event, Object.assign({ step: true }, data || {})); return; }
      if (typeof w.isoTrack === 'function') { w.isoTrack(event); }
    } catch (_) {}
  }

  /* Store-Stub: liest das Dashboard-Projekt read-only (Fallback: leer).
     Module brauchen nur get()/project; set/subscribe sind Standalone no-ops. */
  function makeStore() {
    var project = {};
    try {
      var raw = w.localStorage.getItem('isodash_project_v8');
      if (raw) project = JSON.parse(raw) || {};
    } catch (_) {}
    return {
      project: project,
      get: function () { return project; },
      set: function () {},
      subscribe: function () { return function () {}; }
    };
  }

  /* overrides: pro-Seite gesetzte Routen->URL-Map (data-iso-nav am #mod).
     z.B. Feuchtigkeitsanalyse: {"uebersicht":"/pages/kalkulator"} — leitet den
     Abschluss-CTA des Wizards in den Kalkulator statt ins Dashboard. */
  function makeNavigate(prefix, overrides) {
    return function (route) {
      var url = (overrides && overrides[route]) || NAV_URLS[route] || DASHBOARD_URL;
      track(prefix + '_dashboard_click', { target: String(route || '') });
      w.location.href = url;
    };
  }

  /* Experten-Kontakt: die Shell-Delegation ([data-contact] → IsoDash.Contact)
     existiert standalone nicht — ohne diesen Handler waere der CTA tot. */
  /* v519: data-iso-contact="hendrik-sheet" am #mod (Trocknungs-Guide) oeffnet die
     Hendrik-Schublade (Telefon/WhatsApp/Mail) statt eines nackten WhatsApp-Fensters.
     Die Schublade laedt die Announcement-Bar bei Klick auf [data-iso-hendrik-open]
     nach — wir loesen genau diesen Klick ueber ein kurzlebiges Hilfselement aus,
     damit Loader und Quelle (data-iso-source) an einer Stelle bleiben.
     Ohne Announcement-Bar (oder ohne Attribut) bleibt WhatsApp der Weg. */
  function openHendrikSheet(source) {
    if (!d.querySelector('[data-iso-hendrik-open]')) return false;
    var tmp = d.createElement('span');
    tmp.setAttribute('data-iso-hendrik-open', '');
    tmp.setAttribute('data-iso-source', source);
    tmp.hidden = true;
    d.body.appendChild(tmp);
    tmp.click();
    d.body.removeChild(tmp);
    return true;
  }

  function wireContact(prefix, mode) {
    if (w.__isoStandaloneContactWired) return;
    w.__isoStandaloneContactWired = true;
    d.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-contact]');
      if (!btn) return;
      var root = d.getElementById('isodash');
      if (!root || !root.contains(btn)) return;
      e.preventDefault();
      track(prefix + '_expert_click', { step: true });
      if (mode === 'hendrik-sheet' && openHendrikSheet(prefix + '_expert')) return;
      w.open(WHATSAPP_URL, '_blank', 'noopener');
    }, true);
  }

  function mountModule(mod, name, prefix) {
    var reg = w.IsoDashModules && w.IsoDashModules[name];
    if (!reg || typeof reg.mount !== 'function') return false;
    var overrides = {};
    try {
      var navAttr = mod.getAttribute('data-iso-nav');
      if (navAttr) overrides = JSON.parse(navAttr) || {};
    } catch (_) {}
    try {
      reg.mount({
        root: mod,
        store: makeStore(),
        navigate: makeNavigate(prefix, overrides),
        isMobile: w.innerWidth < 768,
        /* Modul-spezifische Standalone-Optionen (z.B. analyse: data-iso-mode="fa-only",
           data-iso-done-url="/pages/kalkulator") — vom Modul ausgewertet, sonst ignoriert. */
        mode: mod.getAttribute('data-iso-mode') || '',
        doneUrl: mod.getAttribute('data-iso-done-url') || '',
        doneBottom: mod.getAttribute('data-iso-done-bottom') || '',
        doneSide: mod.getAttribute('data-iso-done-side') || ''
      });
    } catch (err) {
      try { console.error('[IsoDash standalone] mount fehlgeschlagen:', name, err); } catch (_) {}
    }
    return true;
  }

  /* Die Dashboard-Shell rendert beim Breakpoint-Wechsel neu — standalone braucht
     das auch, sonst entsteht ein Mischzustand (Desktop-Markup mit Mobile-CSS oder
     umgekehrt) und SVG-Layouts brechen. Remount reicht NICHT: die Module rendern
     Bloecke asynchron nach und hinterlassen sonst beide Varianten im DOM (im
     Preview verifiziert). Reload ist der einzige konsistente Weg — Breakpoint-
     Wechsel per Fenster-Resize ist real selten, der Trade-off ok. */
  function wireBreakpointReload() {
    var lastMobile = w.innerWidth < 768;
    var t = null;
    w.addEventListener('resize', function () {
      if (t) w.clearTimeout(t);
      t = w.setTimeout(function () {
        var nowMobile = w.innerWidth < 768; /* width-basiert: iOS-Scroll-Resize (nur Hoehe) triggert nicht */
        if (nowMobile === lastMobile) return;
        w.location.reload();
      }, 250);
    });
  }

  function mountWithRetry(mod, name, prefix) {
    var tries = 0;
    (function tryMount() {
      if (mountModule(mod, name, prefix)) return;
      tries += 1;
      if (tries < 50) w.setTimeout(tryMount, 120); /* defer-Reihenfolge macht das selten noetig */
    })();
  }

  function boot() {
    var mod = d.getElementById('mod');
    if (!mod) return;
    var name = mod.getAttribute('data-iso-module');
    if (!name) return;
    var prefix = mod.getAttribute('data-iso-prefix') || name;
    wireContact(prefix, mod.getAttribute('data-iso-contact') || '');
    wireBreakpointReload();

    /* Optionaler Startscreen-Gate: data-iso-start="#button" → NICHT automatisch mounten,
       sondern erst beim Klick auf den Button. Der #isodash-Container ist solange hidden;
       beim Start wird er sichtbar gemacht, das Modul gemountet und hinscrollt.
       (Feuchtigkeitsanalyse: Landing zeigt CTA, Tool startet on demand.) */
    var startSel = mod.getAttribute('data-iso-start');
    if (startSel) {
      var iso = d.getElementById('isodash');
      var trigger = d.querySelector(startSel);
      var started = false;
      var go = function (e) {
        if (e) e.preventDefault();
        if (started) return;
        started = true;
        track(prefix + '_start_click', { step: true });
        /* Startscreen-Landing ausblenden, damit das Tool sie ersetzt (nicht darunter erscheint) */
        var hideSel = mod.getAttribute('data-iso-start-hide');
        if (hideSel) { var h = d.querySelector(hideSel); if (h) h.style.display = 'none'; }
        if (iso) iso.hidden = false;
        mountWithRetry(mod, name, prefix);
        try { (iso || mod).scrollIntoView({ block: 'start' }); } catch (_) {}
      };
      if (trigger) {
        trigger.addEventListener('click', go);
        /* v311.6: Auto-Start via ?start=1 (z.B. von der Ad-Landingpage feuchte-wand) →
           Landing ueberspringen, direkt in die erste Frage. Greift nur wenn der Param gesetzt ist. */
        var _autoStart = false;
        try { _autoStart = new w.URLSearchParams(w.location.search).get('start') === '1'; } catch (_) {}
        if (_autoStart) go();
      } else {
        /* Trigger (noch) nicht da → Fallback: normal mounten, damit das Tool nicht tot ist */
        mountWithRetry(mod, name, prefix);
      }
      return;
    }

    mountWithRetry(mod, name, prefix);
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window, document);
